module.exports = __webpack_public_path__ + "img/3F3I.b3b48a35.gif";